import React from 'react';
import LoadingSpinner from 'components/atoms/LoadingSpinner';
import { ButtonProps } from 'types/components.types';
import { Variant } from 'types/common.types';

const Button: React.FC<ButtonProps> = ({ 
  children, 
  onClick, 
  type = 'button', 
  variant = 'primary', 
  disabled = false,
  loading = false,
  className = '',
  ...props 
}) => {
  const baseClasses = 'font-medium transition-colors duration-200 inline-flex items-center justify-center border';
  const variantClasses: Record<Variant, string> = {
    primary: 'h-[35px] rounded-[10px] bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-300 px-[13px] py-[9px]',
    secondary: 'h-[35px] rounded-[10px] bg-gray-600 text-white hover:bg-gray-700 disabled:bg-gray-300 px-[13px] py-[9px]',
    outline: 'h-[44px] rounded-[100px] border-[#CFCFCF] text-gray-700 hover:bg-gray-50 disabled:opacity-50 px-[14px] bg-white min-w-[115px]',
    teal: 'h-[35px] rounded-[10px] bg-teal-600 text-white hover:bg-teal-700 disabled:bg-teal-300 px-[13px] py-[9px] border-teal-600',
    'gray-outline': 'h-[44px] rounded-[100px] bg-white border-[#CFCFCF] text-[#263238] hover:bg-gray-50 disabled:opacity-50 px-[14px] min-w-[115px]'
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${className}`;
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      className={classes}
      {...props}
    >
      {loading && (
        <LoadingSpinner 
          size="sm" 
          color="white" 
          className="mr-2" 
        />
      )}
      {children}
    </button>
  );
};

export default Button;
